<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Dashboard de adquirência
                </h2>
            </div>
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="sm:rounded-lg">
                    <flash :timeout="5000"/>
                    <div class="py-4 grid grid-cols-12 gap-4 ">
                        <div class="col-span-6">
                            <label class="block text-gray-700 text-sm font-bold mb-2">
                                Clientes
                            </label>
                            <jet-auto-complete
                                id="contact" class="mt-1 block w-full"
                                :endpoint="'customers'"
                                :auto-load="true"
                                :custom-option="customCustomerView"
                                @input="reloadTransactions"
                                v-model="customerSelect"
                            />
                        </div>
                        <div class="col-span-6 mt-7 text-right">
                            <div class="inline-flex rounded-md " role="group">
                                <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'today'}" @click="changeFilter('today')"  >
                                    Hoje
                                </button>
                                 <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white border-t border-b border-r border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'yesterday'}"  @click="changeFilter('yesterday')" >
                                   Ontem
                                </button>
                                 <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white border-t border-b border-r border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'last_7_days'}" @click="changeFilter('last_7_days')">
                                    Última semana
                                </button>
                                 <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white border-t border-b border-r border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'last_15_days'}"  @click="changeFilter('last_15_days')">
                                    15 dias
                                </button>
                                 <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'last_30_days'}" @click="changeFilter('last_30_days')">
                                    30 dias
                                </button>
                                <button type="button" class="shadow-sm py-3 px-4 text-sm font-medium text-gray-900 bg-white rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': filterSelected === 'this_month'}" @click="changeFilter('this_month')">
                                    Este mês
                                </button>
                                <button type="button" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-200 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 shadow-sm" v-tippy content="Filtre por data" @click="modalDataFilter = true">
                                    <svg class=" h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="inline-flex mt-5" v-if="params.filter == 'range'">
                                <p>
                                    Período selecionado {{params.start_date | smallDate }} às {{params.start_time}} até {{params.end_date | smallDate }} às {{params.end_time}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-3">
                        <values-card
                            class="bg-blue-600 col-span-3"
                            :label1="'Terminais ativos'"
                            :label2="'Valor de venda'"
                            :value1="terminalsSalesValue.terminalsActive"
                            :value2="terminalsSalesValue.salesValue"
                            :icon="'fas fa-dollar-sign'" />
                        <values-card
                            class="bg-purple-600 col-span-3"
                            :label1="'Transações'"
                            :label2="'Ticket médio'"
                            :value1="transactionsAndTicket.transactions"
                            :value2="transactionsAndTicket.ticket"
                            :icon="'fas fa-list'" />
                        <values-card
                            class="bg-gray-500 col-span-4"
                            :label1="'Pendentes de pagamento'"
                            :label2="'Valor em vendas'"
                            :value1="totalPendingPaymentsAndAmount.pendingTotal"
                            :value2="totalPendingPaymentsAndAmount.pendingAmount"
                            :icon="'fas fa-clock'" />
                        <values-card
                            class="bg-green-600 col-span-2"
                            :label2="'Líquido a receber'"
                            :value2="netReceivable"
                            :icon="'fas fa-wallet'" />
                    </div>
                    <div class="grid grid-cols-12 gap-4 mt-5">
                        <div class="bg-white p-4 rounded-lg col-span-6 shadow-xl">
                            <h2 class="text-center text-lg leading-6 font-medium text-gray-900">
                                Transações por tipo de pagamento
                            </h2>
                            <ul class="list-none mt-5" v-if="data && data.payment_types.length">
                                <li class="text-sm leading-5 text-gray-900 mb-5" v-for="(item, index) in data.payment_types" :key="index">
                                    <div class="grid grid-cols-12 gap-4 mt-2">
                                        <div class="col-span-9">
                                            <div class="flex flex-col">
                                                <div>
                                                    {{types[item.type]}}
                                                </div>
                                                <div class="text-gray-500">
                                                    {{item.total_amount | currency }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-span-3 my-auto text-base">
                                            {{ getPercetage(item.total_amount, data.total_amount) }}%
                                        </div>
                                    </div>
                                    <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                        <div class="bg-blue-600 h-2.5 rounded-full" :style="'width:'+getPercetage(item.total_amount, data.total_amount)+'%'"></div>
                                    </div>
                                </li>
                            </ul>
                            <p v-else class="text-center text-gray-500">
                                Nenhuma transação para o período selecionado
                            </p>
                        </div>
                        <div class="bg-white p-4 rounded-lg col-span-6 shadow-xl">
                            <h2 class="text-center text-lg leading-6 font-medium text-gray-900">
                                Transações por bandeira de cartão

                            </h2>
                            <div class="grid grid-cols-12 gap-4 mt-5"  v-if="data && data.card_brands && data.card_brands.length">
                                <div class="col-span-3 m-3" v-for="(card_brand, index) in data.card_brands" :key="index" >
                                    <div class="text-center ">
                                        <img
                                        class="w-14 border border-gray-200 bg-white rounded-full mx-auto"
                                        v-bind:src="`/images/credit-cards/lightcolor/${card_brand.card_brand.toLowerCase()}.png`"/>
                                        <div class="text-gray-500 mt-2">
                                            {{card_brand.total_amount | currency }}
                                        </div>
                                        {{getPercetage(card_brand.total_amount, data.total_amount)}}%
                                    </div>
                                </div>
                            </div>
                            <p v-else class="text-center text-gray-500">
                                Nenhuma transação para o período selecionado
                            </p>
                        </div>
                    </div>

                    <!-- Valores expressos em Reais (R$) -->
                    <p class="text-right text-gray-500 mt-5">
                        <span class="text-sm font-medium">
                            Valores expressos em Reais (R$)
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <Jet-dialog-modal :show="modalSelect" >
            <template #title>
                Selecione um cliente
            </template>
            <template #content>
                <div class="grid grid-cols-12 gap-4 ">
                    <div class="col-span-12">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Clientes
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full"
                            :endpoint="'customers'"
                            :auto-load="true"
                            :custom-option="customCustomerView"
                            @input="reloadTransactions"
                            v-model="customerSelect"
                        />
                    </div>
                </div>
            </template>

            <template #footer>
                <jet-secondary-button @click.native="modalSelect = false">
                    Cancelar
                </jet-secondary-button>
            </template>
        </Jet-dialog-modal>

        <Jet-dialog-modal :show="modalDataFilter"  >
            <template #title>
                Filtrar por data
            </template>
            <template #content>
                <div class="grid grid-cols-12 gap-4 ">
                    <div class="col-span-6">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Data inicial
                        </label>
                        <jet-date-picker
                            id="date_start"
                            class="mt-1 block w-full"
                            v-model="dateRange.startDate"
                            :disabled-dates="{from: moment().toDate()}"
                        />
                        <jet-input-error :message="formErrors.startDate" class="mt-2"/>

                    </div>
                    <div class="col-span-6">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Hora inicial
                        </label>
                        <input
                            id="time_start"
                            class="mt-1 rounded-md border border-solid border-black text-gray-700 w-full my-1 py-2 px-3 block"
                            type="time" step="2"
                            v-model="dateRange.startTime"
                        />
                        <jet-input-error :message="formErrors.startTime" class="mt-2"/>

                    </div>
                    <div class="col-span-6">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Data final
                        </label>
                        <jet-date-picker
                            id="date_end"
                            class="mt-1 block w-full"
                            v-model="dateRange.endDate"
                            :disabled-dates="{from: moment().toDate() || null}"
                        />
                        <jet-input-error :message="formErrors.endDate" class="mt-2"/>

                    </div>
                    <div class="col-span-6">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Hora final
                        </label>
                        <input
                            id="time_end"
                            class="mt-1 rounded-md border border-solid border-black text-gray-700 w-full my-1 py-2 px-3 block"
                            type="time" step="2"
                            v-model="dateRange.endTime"
                        />
                        <jet-input-error :message="formErrors.endTime" class="mt-2"/>

                    </div>

                </div>
            </template>
            <template #footer>

                <jet-secondary-button @click.native="modalDataFilter = false">
                    Cancelar
                </jet-secondary-button>
                <jet-button class="ml-2" @click.native="changeFilterDate()">
                    Filtrar
                </jet-button>
            </template>
        </Jet-dialog-modal>


    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import JetDialogModal from './../../Jetstream/DialogModal'
import JetSecondaryButton from './../../Jetstream/SecondaryButton'
import JetDatePicker from './../../Jetstream/DatePicker';
import JetButton from './../../Jetstream/Button';
import JetInputError from './../../Jetstream/InputError';
import moment from 'moment';
import ValuesCard from './components/ValuesCard.vue';

export default {
    components: {
        JetInputError,
        JetButton,
        JetDatePicker,
        JetSecondaryButton,
        JetDialogModal,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        ValuesCard
    },
    props: ['data','filter','customer'],
    data() {
        return {
            moment: moment,
            formErrors: {},
            dateRange:{
                startDate: null,
                startTime: '00:00:00',
                endDate: null,
                endTime: '23:59:59',
            },
            modalDataFilter: false,
            filterSelected:this.filter,
            scopes: {
                reseller: 'Revendedor',
                seller: 'Vendedor',
                holder: 'Estabelecimento',
                admin: 'Admin',
                partner: 'Parceiro',
                customer: 'Cliente',
                employee: 'Colaborador',
            },
            modalSelect: false,
            customerSelect:{},
            types : {
                debit: 'Débito',
                credit: 'Crédito',
                credit_installments: 'Crédito parcelado',
            },
            params: {
                sort: 'name:asc',
                page: 1,
                ...this.$page.props.queryString
            },
        }
    },
    computed: {
        terminalsSalesValue(){
            if(!this.data) return {}
            return {
                terminalsActive: this.data.devices.length ?? 0,
                salesValue: this.data.total_amount ?? 0
            }
        },
        transactionsAndTicket(){
            if(!this.data) return {}
            return {
                transactions: this.data.transactions ?? 0,
                ticket: this.data.avg_ticket ?? 0
            }
        },
        totalPendingPaymentsAndAmount(){
            if(!this.data) return {}
            const statusAwaitingPayment = 3
            const pendingPayments = this.data.payment_status.find(payment => payment.status === statusAwaitingPayment) || {}
            return {
                pendingTotal: pendingPayments.transactions ?? 0,
                pendingAmount: pendingPayments.total_amount ?? 0
            }
        },
        netReceivable(){
            if(!this.data) return 0
            return (this.data.total_amount - this.data.total_charged) ?? 0
        }
    },
    methods: {
        clearErrors(){
            this.formErrors = {
                startDate: null,
                startTime: null,
                endDate: null,
                endTime: null,
            };
        },
        changeFilterDate(){
            let isValid = true;
            this.clearErrors();
            if(this.dateRange.startDate > this.dateRange.endDate ){
                this.formErrors.startDate = "Data inicial não pode ser maior que a data final";
                isValid = false;
            }

            if(!this.dateRange.startDate){
                this.formErrors.startDate = "Data inicial é obrigatória";
                isValid = false;
            }
            if(!this.dateRange.endDate){
                this.formErrors.endDate = "Data final é obrigatória";
                isValid = false;
            }
            if(!this.dateRange.startTime){
                this.formErrors.startTime = "Hora inicial é obrigatória";
                isValid = false;
            }
            if(!this.dateRange.endTime){
                this.formErrors.endTime = "Hora final é obrigatória";
                isValid = false;
            }



            if(!isValid){
                return;
            }

            let params = {
                start_date: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                start_time: this.dateRange.startTime,
                end_date: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                end_time: this.dateRange.endTime,
                customer_id: this.customerSelect.id,
                filter:'range',
            };

            this.$inertia.get(this.route('acquiring.dashboard', params));
        },
        changeFilter(filterSelected){
            if(this.filterSelected == filterSelected){
                return;
            }
            this.$inertia.get(this.route('acquiring.dashboard', {'customer_id':this.customerSelect.id,'filter':filterSelected}));
        },
        reloadTransactions(e){
            if(e && e.id){
                window.localStorage.setItem('connectedCustomer', JSON.stringify(e));
                this.$inertia.get(this.route('acquiring.dashboard', {'customer_id':e.id}));
            }else{
                this.$inertia.get(this.route('acquiring.dashboard',{'clear':true}));
            }

        },
        customCustomerView(option) {

            var name = option.name;
            var scopes = option.scope || [];

            scopes = scopes.map(scope => this.scopes[scope]).join(', ');

            return `
                <div class="flex items-center">
                    <div class="ml-3">
                        <div class="text-xs leading-none font-medium text-gray-900">${name}</div>
                        <div class="text-xs leading-none text-gray-500">${scopes}</div>
                    </div>
                </div>
            `;

        },
        getPercetage(value, total) {
            return ((value / total) * 100).toFixed(2);
        },
        show: function (item) {
            this.$inertia.get(this.route('contact.show', item.id));
        }
    },
    created() {
        if(!this.customer){
            this.modalSelect = true;
        }else{
            this.customerSelect = this.customer;
        }

        if(this.params.filter == 'range'){
            this.dateRange = {
                startDate: moment(this.params.start_date).format('YYYY-MM-DD'),
                startTime: this.params.start_time,
                endDate: moment(this.params.end_date).format('YYYY-MM-DD'),
                endTime: this.params.end_time,
            };
        }
    },
}


</script>
